import styled from "styled-components";
const ComponentSc = styled.div`
  @media (max-width: 700px) {
    .navbar-rightside-comp {
      display: none;
    }

    .nav-bar-left-side-logos {
      justify-content: center;
    }

    .dropdown-content {
      width: 100%;
    }

    .navbar-profile-pic-btn {
      display: none;
    }

    .greeting-name {
      display: none;
    }
    .hamburger-menu {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 10%;
      height: 10%;
      position: relative;
    }

    .menu-button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 45px;
      height: 45px;
      background-color: transparent;
      border: none;
      cursor: pointer;
    }

    .bar {
      width: 25px;
      height: 3px;
      background-color: #333;
      margin: 4px 0;
      transition: transform 0.2s ease-in-out;
    }

    .open .bar:nth-child(1) {
      transition: all 100ms ease-in-out;
      transform: rotate(55deg);
      transform-origin: top left;
      width: 28px;
    }

    .open .bar:nth-child(2) {
      transition: all 100ms ease-in-out;
      transform-origin: center;
      width: 0;
    }

    .open .bar:nth-child(3) {
      transition: all 100ms ease-in-out;
      transform: rotate(-55deg);
      transform-origin: bottom left;
      width: 28px;
    }

    .drop-down-heading {
      display: flex;
      flex-direction: column;

      padding: 1rem;

      color: black;
    }
    .list-containers {
      padding: 0.8rem;
      margin-left: 3px;
    }
    .list-items {
      padding: 0.8rem;
    }
    .list-container:hover {
      background-color: rgba(122, 122, 221, 0.829);
    }
    .list-items:hover {
      background-color: rgba(122, 122, 221, 0.829);
      padding: 0.8rem;
    }
  }
`;
export default ComponentSc;
